// extracted by mini-css-extract-plugin
module.exports =  {"card":"RhPfAWu","fade-in":"ahhe8SY","fadeIn":"ahhe8SY","expired":"HZMq5sK"};